var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHazardIndex(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 141.7 147.6",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.7,
    y: 77.1,
    width: 17.7,
    height: 50.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 41.8,
    width: 17.7,
    height: 86.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.3,
    y: 59.4,
    width: 17.7,
    height: 68.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "126,124.1 130,129.4 121.2,129.4 121.2,125 116.8,125 116.8,129.4 85.9,129.4 85.9,125 81.5,125     81.5,129.4 50.6,129.4 50.6,125 46.1,125 46.1,129.4 15.3,129.4 15.3,14.7 20.5,18.6 23.2,15.1 13,7.5 2.9,15.1 5.5,18.6     10.8,14.7 10.8,133.8 130,133.8 126,139.1 129.6,141.8 137.2,131.6 129.6,121.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3,5.8v13.2H66v22.1h4.4V23.5h19.9v13.2h48.6V5.8H90.3z M134.4,32.3H94.7V10.3h39.7V32.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.1,
    y: 14.7,
    width: 30.9,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.6,
    y: 23.5,
    width: 4.4,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.1,
    y: 23.5,
    width: 22.1,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.1,
    y: 80.9,
    width: 4.4,
    height: 39.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.5,
    y: 45.6,
    width: 4.4,
    height: 75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 63.2,
    width: 4.4,
    height: 57.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHazardIndex);
export default __webpack_public_path__ + "static/media/icon-hazard-index.76d12db05d2e875a510ed9da60b8938f.svg";
export { ForwardRef as ReactComponent };